<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div
        class="form-title padding-title"
        v-text="'Reclamo Camión'"
      />
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_combo_text"
              v-text="text"
            />
            <!-- 1 -->
            <div
              class="form_label"
              v-text="'Nombre *'"
            />
            <div class="form__field">
              <label for="name"><v-icon
                name="user"
                scale="1"
              /></label>
              <input
                id="name"
                ref="name"
                v-model="name"
                autocomplete="off"
                type="text"
                name="name"
                value=""
                placeholder="Nombre"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('name', 'name')"
              >
            </div>
            <!-- 2 -->
            <div
              class="form_label"
              v-text="'Correo electrónico *'"
            />
            <div class="form__field">
              <label
                for="correo"
              ><v-icon
                name="envelope"
                scale="1"
              /></label>
              <input
                id="correo"
                ref="correo"
                v-model="correo"
                class="correo"
                autocomplete="off"
                type="text"
                name="correo"
                value=""
                placeholder="usuario@dominio.com"
                required
                @focus="_clearError"
              >
            </div>
            <!-- 3 -->
            <div
              class="form_label"
              v-text="'Teléfono *'"
            />
            <div class="form__field">
              <label
                for="telefono"
              ><v-icon
                name="mobile-alt"
                scale="1"
                style="margin: 0 2px 3px 4px"
              /></label>
              <input
                id="telefono"
                ref="telefono"
                v-model="telefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="+569 1 234 5678"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
              >
            </div>
            <!-- 4 -->
            <div
              class="form_label"
              v-text="'RUT *'"
            />
            <div class="form__field">
              <label
                for="rut"
              ><v-icon
                name="address-card"
                scale="1"
              /></label>
              <input
                id="rut"
                ref="rut"
                v-model="rut"
                autocomplete="off"
                type="text"
                name="rut"
                value=""
                placeholder="XX.XXX.XXX-X"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'rut')"
                @change="_formatearRut($event.target.value)"
              >
            </div>
            <!-- 5 -->
            <div
              class="form_label"
              v-text="'Ciudad *'"
            />
            <div class="form__field">
              <label
                for="ciudad"
              ><v-icon
                name="city"
                scale="1"
              /></label>
              <input
                id="ciudad"
                ref="ciudad"
                v-model="ciudad"
                autocomplete="off"
                type="text"
                name="ciudad"
                value=""
                placeholder="Santiago"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'ciudad')"
                @change="cleanSpecialChars('ciudad', 'ciudad')"
              >
            </div>
            <!-- 6 -->

            <!-- 7 -->
            <div
              class="form_label"
              v-text="'N° Camión*'"
            />
            <div class="form__field">
              <label for="numberCamion"><v-icon
                name="list-ol"
                scale="1"
              /></label>
              <input
                id="numberCamion"
                ref="numberCamion"
                v-model="numberCamion"
                autocomplete="off"
                type="text"
                name="numberCamion"
                value=""
                placeholder="00"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'numberCamion')"
                @change="cleanSpecialChars('numberCamion', 'numberCamion')"
              >
            </div>
            <!-- 8 -->
            <div
              class="form_label"
              v-text="'Patente*'"
            />
            <div class="form__field">
              <label for="patente"><v-icon
                name="city"
                scale="1"
              /></label>
              <input
                id="patente"
                ref="patente"
                v-model="patente"
                autocomplete="off"
                type="text"
                name="patente"
                value=""
                placeholder="XXXXXX"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'patente')"
                @change="cleanSpecialChars('patente', 'patente')"
              >
            </div>
            <!-- IMAGEN --><!-- IMAGEN -->
            <div class="form__field">
              <input
                class="form_image"
                type="file"
                accept="image/*"
                @change="handleImageUpload"
              >
            </div>
            <div
              v-if="image"
              class="form__field"
            >
              <img
                :src="image"
                alt="Imagen seleccionada"
                class="max-image-size"
              >
            </div>
            <!-- IMAGEN --><!-- IMAGEN -->

            <!-- TEXTAREA -->
            <div class="form_label">
              Comentario
            </div>
            <div class="score-comments">
              <textarea
                v-model="comentario"
                style="white-space: pre-line"
                placeholder="Escribe que pasó..."
              />
            </div>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/store'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/id-card'
import 'vue-awesome/icons/barcode'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/tools'
import 'vue-awesome/icons/mobile-alt'
import 'vue-awesome/icons/city'
import 'vue-awesome/icons/question-circle'
import 'vue-awesome/icons/window-maximize'
import utils from './utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {},
  data () {
    return {
      name: '',
      correo: '',
      telefono: '',
      rut: '',
      ciudad: '',
      comentario: '',
      numberCamion: '',
      patente: '',
      evidence: '',
      text: '',
      errormsg: '',
      nombre: '',
      mail: '',
      fono: '',
      rutD: '',
      city: '',
      comment: '',
      number: '',
      patent: '',
      base64: '',
      file: null,
      image: null,
      base64Data: ''

    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'CCUReclamoCamionForm') return
      if (e.evento === 'newdata') {
        this.nombre = e.dato.fields.name ? e.dato.fields.name : ''
        this.mail = e.dato.fields.email ? e.dato.fields.email : ''
        this.fono = e.dato.fields.phone ? e.dato.fields.phone : ''
        this.rutD = e.dato.fields.rut ? e.dato.fields.rut : ''
        this.city = e.dato.fields.ciudad ? e.dato.fields.ciudad : ''
        this.comment = e.dato.fields.comentario ? e.dato.fields.comentario : ''
        this.number = e.dato.fields.numberCamion ? e.dato.fields.numberCamion : ''
        this.patent = e.dato.fields.patente ? e.dato.fields.patente : ''

        // data
        this.name = this.nombre
        this.correo = this.mail
        this.telefono = this.fono
        this.rut = this.rutD
        this.ciudad = this.city
        this.comentario = this.comment
        this.numberCamion = this.number
        this.patente = this.patent
      }
    })
  },
  methods: {
    _clearError () {
      this.errormsg = ''
    },
    handleImageUpload (e) {
      const file2 = e.target.files[0]
      this.file = file2
      this.image = URL.createObjectURL(file2)
      if (file2) {
        const reader = new FileReader()

        reader.onload = () => {
          // The result contains the base64 encoded string
          this.base64Data = reader.result.split(',')[1]
          this.base64 = reader.result
        }

        reader.readAsDataURL(file2)
      }
    },
    focusTo (el) {
      this.$refs[el].focus()
    },
    _formatearRut (val) {
      this.rut = utils.cleanSpecialChars(val, 'rut')
      this.rut = utils.formatearRut(this.rut)
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.name) {
        this.$refs.name.focus()
        this.errormsg = 'Debes ingresar tu nombre'
        return
      }
      if (!this.correo) {
        this.$refs.correo.focus()
        this.errormsg = 'Debes ingresar tu correo'
        return
      }
      if (!this.telefono) {
        this.$refs.telefono.focus()
        this.errormsg = 'Debes ingresar telefono'
        return
      }
      if (!this.rut) {
        this.$refs.rut.focus()
        this.errormsg = 'Debes ingresar tu RUT'
        return
      }
      if (!this.ciudad) {
        this.$refs.ciudad.focus()
        this.errormsg = 'Debes ingresar ciudad'
        return
      }
      if (!this.comentario) {
        this.$refs.comentario.focus()
        this.errormsg = 'Debes ingresar lo que pasó'
        return
      }
      if (!this.comentario) {
        this.errormsg = 'Debes ingresar comentario'
        return
      }
      if (!this.numberCamion) {
        this.$refs.numberCamion.focus()
        this.errormsg = 'Debes seleccionar número de camión'
        return
      }
      if (!this.patente) {
        this.$refs.patente.focus()
        this.errormsg = 'Debes ingresar patente'
        return
      }

      serverUI.$emit('FormEvent', {
        form: 'CCUReclamoCamionForm',
        evento: 'sentClick',
        data: {
          type: 'ccu-reclamo-camion-form-confirm',
          fields: {
            name: this.name,
            correo: this.correo,
            telefono: this.telefono,
            rut: this.rut,
            ciudad: this.ciudad,
            comentario: this.comentario,
            numberCamion: this.numberCamion,
            patente: this.patente,
            base64: this.base64
          }
        }
      })
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'CCUReclamoCamionForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}

.form-box-body {
    height: 340px;
}
</style>
